import { toast } from "react-toastify";
import { centralPatientConstants } from "../../_constants/centralConstant/centralPatient.constant";
import { getCentralPatientLists } from "../../_services";
import { alertActions } from "../alert.actions";
import { configActions } from "../config.actions";

function getCentralPatientList(params) {
  console.log({params})
    return (dispatch,getState) => {
      dispatch(request());
      dispatch(configActions.showSpinningLoader());
      getCentralPatientLists(params).then(
          (res) => {
            dispatch(success(res));
  
            // !!res?.description && toast.success(res.description)

            //callback added for the support of the the caching work
            // Boolean(callback) && callback(res);
  
            dispatch(configActions.hideSpinningLoader());
  
            // history.push("/");
          },
          (error) => {
        toast.error(error.description)
            dispatch(failure(error));
            dispatch(alertActions.error(error));
          }
        );
        // dispatch(success(cache));
        dispatch(configActions.hideSpinningLoader());
    };
  
    function request() {
      return {
        type: centralPatientConstants.CENTRAL_PATIENT_LIST_REQUESTING,
      };
    }
    function success(res) {
      return {
        type: centralPatientConstants.CENTRAL_PATIENT_LIST_FETCHED,
        centralPatients: res,
      };
    }
    function failure(error) {
      return { type: centralPatientConstants.CENTRAL_PATIENT_LIST_FAILED, error };
    }

  }
  const clearCentralPatientList=()=>{
    return (dispatch)=>{
      dispatch({type:centralPatientConstants.CLEAR_CENTRAL_PATIENT_LIST})
    }
  }

  
export const centralPatientActions = {
  getCentralPatientList,
  clearCentralPatientList
};

